"use client";

import { InterestGroup } from "../../../app/storyblok/[localeString]/support-hub/types/contact.types";
import type { TypesenseSearchFieldProps } from "../TypesenseSearchField/TypesenseSearchField";
import { DesktopMenu } from "./DesktopMenu";
import { MobileMenu } from "./MobileMenu";

export function SideMenu({
  pageTitle,
  pageIntro,
  interestGroupsLabel,
  interestGroups,
  categoriesLabel,
  topicsLabel,
  variant,
  filterPanelClearAllLabel,
  refineResultsLabel,
  showResultsLabel,
  filterResultsLabel,
  resultsLabel,
  typesenseSearch,
}: {
  pageTitle: string;
  pageIntro?: React.ReactNode;
  interestGroupsLabel: string;
  interestGroups: InterestGroup[];
  categoriesLabel: string;
  topicsLabel: string;
  variant: "desktop" | "mobile";
  filterPanelClearAllLabel: string;
  refineResultsLabel: string;
  showResultsLabel: string;
  filterResultsLabel: string;
  resultsLabel: string;
  typesenseSearch?: TypesenseSearchFieldProps;
}) {
  if (variant === "desktop") {
    return (
      <DesktopMenu
        pageTitle={pageTitle}
        pageIntro={pageIntro}
        interestGroupsLabel={interestGroupsLabel}
        interestGroups={interestGroups}
        categoriesLabel={categoriesLabel}
        topicsLabel={topicsLabel}
        filterPanelClearAllLabel={filterPanelClearAllLabel}
        resultsLabel={resultsLabel}
        typesenseSearch={typesenseSearch}
      />
    );
  }

  return (
    <MobileMenu
      pageTitle={pageTitle}
      pageIntro={pageIntro}
      interestGroupsLabel={interestGroupsLabel}
      interestGroups={interestGroups}
      categoriesLabel={categoriesLabel}
      topicsLabel={topicsLabel}
      filterPanelClearAllLabel={filterPanelClearAllLabel}
      refineResultsLabel={refineResultsLabel}
      showResultsLabel={showResultsLabel}
      filterResultsLabel={filterResultsLabel}
      resultsLabel={resultsLabel}
      typesenseSearch={typesenseSearch}
    />
  );
}
